<app-canvas-record-setup
	*ngIf="canvasSelected"
	#canvasRecordSetup
	[canvasKey]="canvasSelected.canvasKey"
	[duplicateCanvasKey]="duplicateCanvasKey"
	(canvasRecordClearEmitter)="canvasSelected = undefined; duplicateCanvasKey = undefined"
	(canvasRecordSaveEmitter)="canvasSelected = undefined; duplicateCanvasKey = undefined"
	(canvasRecordDeletedEmitter)="canvasRemoveFromList($event)"
></app-canvas-record-setup>

<div class="d-flex card" *ngIf="!canvasSelected">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Canvases</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised  p-button-warning ms-2 my-2" (click)="prepareCanvasSort(); sbReorderGroups.open()">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'sort-shapes-down']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
			<p-button pRipple styleClass="p-button-raised  ms-2 my-2" (click)="newRecord = true">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="canvasListDisplayed"
		[loading]="!canvasListDisplayed"
		[globalFilterFields]="app.keys(canvasListDisplayed)"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} canvases"
		[filterDelay]="0"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="w-100 me-4">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
				<div class="ms-auto d-flex">
					<div class="my-auto">
						<p-inputSwitch [(ngModel)]="canvasViewOffline" (onChange)="canvasViewOfflineChange()"></p-inputSwitch>
					</div>
					<div class="display-14 my-auto d-flex text-right">Show Offline Canvases</div>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="name">
					<div class="d-flex w-100">
						Name
						<p-sortIcon field="name"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="name" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="displayName">
					<div class="d-flex w-100">
						Display Name
						<p-sortIcon field="displayName"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="displayName" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="online">
					<div class="d-flex w-100 justify-content-center text-center">
						Online
						<p-sortIcon field="online"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="boolean" field="online" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="source">
					<div class="d-flex w-100">
						Source
						<p-sortIcon field="source"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="source" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">Stats</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td (click)="canvasSelect(rec.canvasKey)">
					<span class="p-column-title">Canvas Name</span>
					{{ rec.name }}
				</td>
				<td (click)="canvasSelect(rec.canvasKey)">
					<span class="p-column-title">Display Name</span>
					{{ rec.displayName }}
				</td>
				<td (click)="canvasSelect(rec.canvasKey)">
					<span class="p-column-title">Online</span>
					<p-inputSwitch [(ngModel)]="rec.online" (onChange)="venueService.canvaseSave(rec)"></p-inputSwitch>
				</td>
				<td (click)="canvasSelect(rec.canvasKey)">
					<span class="p-column-title">Source</span>
					<span *ngIf="rec.canvasKey >= 100000">Online</span>
					<span *ngIf="rec.canvasKey < 100000">POS</span>
				</td>
				<td (click)="canvasSelect(rec.canvasKey)">
					<span *ngIf="rec.includedItemCanvas">
						<i>Included Item Canvases</i>
					</span>
					<span *ngIf="!rec.includedItemCanvas"> {{ rec.countOnline }} items online </span>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="8">No canvas found.</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="loadingbody">
			<tr>
				<th colspan="8">
					<div class="d-flex w-100">
						<div class="mx-auto display-10">Loading... please wait.</div>
					</div>
				</th>
			</tr>
		</ng-template>
	</p-table>
</div>

<focus-sidebar #sbReorderGroups header="Reorder Canvases" [showCloseIcon]="true" size="xxs" [dismissible]="false" (onClose)="onCanvasReorder()">
	<p-orderList [value]="canvasListOnlineOnly">
		<ng-template let-item pTemplate="item">
			<div>
				{{ item.displayName || item.name }}
			</div>
		</ng-template>
	</p-orderList>
</focus-sidebar>

<ng-template #opImage>
	<div style="width: 150px; height: 150px">
		<img
			*ngIf="imageKeySelected"
			class="w-100"
			[src]="
				'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueService.venueKey + '/' + imageKeySelected + '.png?' + imgCrop.timestamp
			"
			onError="this.src=''"
		/>
	</div>
</ng-template>

<app-canvas-new-prompt *ngIf="newRecord" [(newRecord)]="newRecord" (canvasKeyChange)="canvasSelect($event)"></app-canvas-new-prompt>
